import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import {loadingBarOptions} from '@/config'

Vue.use(VueProgressBar, loadingBarOptions)
